import AcceptingPayments from './views/acceptingPayments.c';
export default AcceptingPayments;
